import { render, staticRenderFns } from "./PanelSection.vue?vue&type=template&id=617e1564&scoped=true&"
import script from "./PanelSection.vue?vue&type=script&lang=js&"
export * from "./PanelSection.vue?vue&type=script&lang=js&"
import style0 from "./PanelSection.vue?vue&type=style&index=0&id=617e1564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e1564",
  null
  
)

export default component.exports